import React, { useMemo } from "react";
import Heading from "@unum/heading";
import { SharedProps } from "./types";
import classnames from "classnames";
import styles from "./Hero.module.scss";

const Generic = ({ title, children, asset, ctas }: SharedProps) => {
  const imageNode = useMemo(() => {
    if (!React.isValidElement<{ className: string }>(asset)) {
      return asset;
    }
    return React.cloneElement(asset, {
      className: classnames(asset.props.className, "hero__image")
    });
  }, [asset]);

  return (
    <div
      className={classnames(
        styles["Hero"],
        styles["Hero--generic"],
        "hero hero--curve-white hero--landing hero-landing"
      )}
    >
      <div
        className={classnames("hero__image-wrapper", styles["image-wrapper"])}
      >
        {imageNode}
      </div>
      <div className="hero__overlap-container">
        <div className="spring">
          <div className="hero-landing__content">
            <div className="row">
              <div className="col-xs-12  col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2">
                <Heading level={1} className="hero__heading">
                  {title}
                </Heading>
              </div>
              {children && (
                <div className="col-xs-12 col-lg-6 col-lg-offset-3">
                  <p
                    className={classnames(
                      "hero-landing__text",
                      styles["landing-text"]
                    )}
                  >
                    {children}
                    {ctas}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Generic;
